import styled from 'styled-components'
import { DefaultFontStyle, DefaultBackground } from '../../../styles/global-styles'

interface BackgroundProps {
  isOpen?: boolean
}

interface ComboTextProps {
  isDisabled?: boolean
}

type DropDownItemProps = {
  isDisabled?: boolean
}

export const Background = styled.div<BackgroundProps>`
  ${DefaultBackground};
  opacity: 0;
  ${({ isOpen }) => !isOpen && 'display: none'};
  top: 100px;
`

export const DropDownContainer = styled.div`
  position: relative;
`
export const Label = styled.label`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  margin: 30px 0 0;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 18px;
  }
`

export const Input = styled.input`
  ${DefaultFontStyle};
  color: ${props => (props.disabled ? '#D3D3D3' : props.theme.colours.black)};
  font-size: 14px;
  margin: 8px 0;
  border: none;
  font-size: 14px;
  padding: 0;
  width: 100%;
  z-index: 10;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 16px;
  }

  &:hover,
  &:focus,
  &:active {
    outline: none;
    cursor: ${props => (props.disabled ? 'auto' : 'text')};
  }
`

export const ComboInput = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #b8b8b8;
  margin: 10px 0 45px 0;
`

export const BookingComboInput = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #b8b8b8;
  margin: 15px 0 45px 0;
`

export const ComboText = styled.p<ComboTextProps>`
  ${DefaultFontStyle};
  margin: 8px 0;
  color: ${props => (props.isDisabled ? 'gray' : props.theme.colours.black)};

  font-size: 14px;
  text-align: left;
  ${({ isDisabled }) => isDisabled && 'cursor: not-allowed'};
  display: flex;
  flex-direction: row;
  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 16px;
  }
`

export const DropDownList = styled.div`
  position: absolute;
  background-color: ${props => props.theme.colours.white};
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: 10px;
  max-height: 250px;
  overflow: auto;
  z-index: 11;
  margin-top: -38px;
`

export const DropDownItem = styled.div<DropDownItemProps>`
  margin: 0;
  padding: 2px 10px;
  &:hover {
    background-color: ${props => props.theme.colours.darkRed}20;
    cursor: pointer;
  }
  ${({ isDisabled }) => isDisabled && 'cursor: not-allowed'};
`

export const DropDownSelected = styled.div`
  margin: 0;
  margin-top: -15px;
  padding: 2px 10px;
  background-color: #ffff;
`
